import React from 'react';
import axios from 'axios';
import SearchForm from '../../component/SearchForm';
import { Link, withRouter } from 'react-router-dom';
import Pagination from '../../component/Pagination';
import InvoiceStatus from '../../component/InvoiceStatus';
import AlertLabel from '../../component/AlertLabel';
import { Field, reduxForm } from 'redux-form';
import { RenderDatePicker, RenderSearchForm } from '../../component/formInput';
import { connect } from 'react-redux';
import moment from 'moment';
import { StringUtils } from '../../utils/javascriptUtils';
var numeral = require('numeral');
var _ = require('lodash');

function AccountTypeCase(accountType) {
  switch(accountType) {
    case "primary": {
      return "TK Chính"
    }
    case "secondary" : {
      return "TK KM"
    }
    default: {
      return "Tất cả "
    }
  }
}

function AccountTypeSelect(accountTypeSelected, onAccountTypeChange) {
  return (
    <div style={{float: 'right'}} className="btn-group">
      <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
        {AccountTypeCase(accountTypeSelected)}
      </button>
      <div className="dropdown-menu" x-placement="bottom-start">
        <a onClick={() => onAccountTypeChange("all")} className="dropdown-item">Tất cả</a>
        <a onClick={() => onAccountTypeChange("primary")} className="dropdown-item">TK Chính</a>
        <a onClick={() => onAccountTypeChange("secondary")} className="dropdown-item">TK Khuyến Mãi</a>
      </div>
    </div>
  )
}

function BillingDatePicker(from_date, to_date, onDateChange, clearDataFilter) {
 
  return ( 
    <div style={{float: "right"}}>
      <div style={{display: 'inline-flex', marginRight:10 }}>
        <span className="input-group-text" style={{height:'fit-content'}}>
          <i style={{ height:20 }} className="icon-calendar22"></i>
        </span>
        <Field
          name="from_date"
          placeholder="dd/mm/yyyy"
          dateFormat="dd/MM/yyyy"
          onChangeAction={(value)=>onDateChange(value, to_date)}
          component={RenderDatePicker}
          />
      </div>
      <div style={{display: 'inline-flex', marginRight:10 }}>
        <span className="input-group-text" style={{height:'fit-content'}}>
          <i style={{ height: 20 }} className="icon-calendar22"></i>
        </span>
        <Field
          name="to_date"
          placeholder="dd/mm/yyyy"
          dateFormat="dd/MM/yyyy"
          onChangeAction={(value)=>onDateChange(from_date, value)}
          component={RenderDatePicker}/>
      </div>
      <div style={{display: 'inline-flex',height:'fit-content'}}>
        <button onClick={()=> clearDataFilter()} style={{whiteSpace:'nowrap', width:'inherit'}} className="btn btn-warning">x</button>
      </div>
    </div>
  )
}

function BillingRows(data) {
  const billing_rows = _.map(data, function(i, index) {
    return (
      <tr key={index} className={i.amount < 0 && "alpha-orange"} style={{borderBottom: "1px solid #ddd"}}>
        <td>
          {i.code}
          <br/>
          <small>{i.description}</small>
        </td>
        <td>
          {i.user && i.user.full_name}
          <br/>
          <small className="text-muted">{i.user && i.user.email}</small>
        </td>
        <td>
          {numeral(i.amount).format("0,0")}
        </td>
        <td>
          {i.account_type}
        </td>
        <td>{moment(i.bill_date).format("DD/MM/YYYY hh:mm:ss")}</td>
      </tr>
      )
  })
  return billing_rows;
}

class BillingTable extends React.Component {
  constructor(props) {
    const {account_type} = props.routeProps.match.params;
    super(props);
    this.state = {
      table_data: [],
      table_query: {
        current_page: 1,
        number_of_row: 20,
        sort_by: "",
        sort_asc: false,
        from_date: null,
        to_date: null,
        search_value: "",
        account_type: account_type,
        alert_label: null
      },
    }
  }

  componentDidMount() {
    this.reload(this.state.table_query);
  }

  gotoPage = (page) => {
    const table_query = {
      ...this.state.table_query,
      current_page: page
    };
    this.reload(table_query);
  }
  
  reload = (table_query) => {
    const self = this;

    axios({
      method: 'post',
      url: window.api_url + '/admin/api/billing/list',
      withCredentials: true,
      data: table_query
    }).then(function (response) {
      self.setState({
        ...self.state,
        table_query: table_query,
        table_data: response.data.data
      })
    });
  }

  onDateChange = (from_date, to_date) => {
    const table_query = {
      ...this.state.table_query,
      search_value: "",
      current_page: 1,
      from_date: moment(from_date).format("YYYY-MM-DD hh:mm:ss"),
      to_date: moment(to_date).format("YYYY-MM-DD hh:mm:ss")
    };
    this.setState({
      ...this.state,
      table_query: table_query
    });

    if(from_date && to_date) {
      this.reload(table_query);
    }
  }

  onSearchSubmit = (values) => {
    const search_value = values.search ? values.search : "";
    const { history } = this.props;
    const table_query = {
      ...this.state.table_query,
      search_value: search_value,
      current_page: 1,
      account_type: "all"

    };
    history.push("?search=" + search_value);
    this.reload(table_query);
  }

  clearDataFilter = () => {
    const { reset } = this.props;
    const table_query = {
      ...this.state.table_query,
      search_value: "",
      current_page: 1,
      from_date: null,
      to_date: null,
      account_type: "all"
    };
    this.setState({
      ...this.state,
      table_query: table_query
    });
    reset();
    this.reload(table_query);
  }

  onKeyPess = (key_code) => {
    const { history, role_path } = this.props;
    if (key_code == "Escape") {
      history.push(role_path + "/billing/all")
      this.clearDataFilter();
    }
  }

  onAccountTypeChange = (account_type) => {
    const { history, role_path } = this.props;
    const table_query = {
      ...this.state.table_query,
      account_type: account_type
    };
    this.reload(table_query);
    history.push(role_path + "/billing/"+ account_type)
  }

  render() {
    const { handleSubmit } = this.props;
    const { table_query, table_data } = this.state;
    const { title } = this.props;
    return(
      <React.Fragment>
        <div className="page-header">
          <div className="page-header-content header-elements-md-inline">
            <div className="page-title d-flex">
              <h4>
                <i className="icon-paragraph-justify2 mr-2"></i>
                <span className="text-semibold">Danh Sách Mã Thanh Toán</span>
              </h4>
            </div>
          </div>
        </div>
        <br/>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-body">
            <form style={{display:"inline-flex"}} onSubmit={handleSubmit(this.onSearchSubmit)}>
                <div style={{ width:"100%", paddingRight:5}}>
                  <Field
                    name="search"
                    placeholder="Mã thanh toán - Email khách hàng"
                    defaultValue = {table_query.search_value}
                    onKeyAction={(ev)=> this.onKeyPess(ev)}
                    component={RenderSearchForm}
                  />
                </div>
              </form>
              {StringUtils.isEmptyOrSpaces(table_query.search_value) && <div className="row">
                <div className="col-md-6">
                </div>
                <div className="col-md-6">
                  {BillingDatePicker(table_query.from_date, table_query.to_date, this.onDateChange, this.clearDataFilter)}
                </div>
              </div>}
              
              <div className="table-responsive">
                {StringUtils.isEmptyOrSpaces(table_query.search_value) && <div className="row">
                  <div className="col-md-6">
                  </div>
                  <div className="col-md-6">
                    {AccountTypeSelect(table_query.account_type, this.onAccountTypeChange)} 
                  </div>
                </div>}
                <table className="table table-togglable table-hover default footable-loaded footable">
                  <thead>
                  <tr>
                    <th data-toggle="true" className="footable-visible footable-first-column">
                      Code
                      <br/>
                      <small className="display-block text-muted text-size-small">Nội dung</small></th>
                    <th>Khách Hàng</th>
                    <th data-hide="phone,tablet" className="">
                      Số tiền
                    </th>
                    <th data-hide="phone,tablet" className="">
                      Loại TK
                    </th>
                    <th data-hide="phone" className="">Ngày</th>
                  </tr>
                  </thead>
                  <tbody>
                    {table_data.data && BillingRows(table_data.data)}
                  </tbody>
                </table>
              </div>
            </div>
            <Pagination query={table_query} data={table_data} handle={this.gotoPage}/>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapState = state => ({
  userProfile: state.userProfile.data,
  role_path: state.userProfile.role_path,
});

const mapDispatch = (dispatch) => ({

});

const BillingTableWrapper = reduxForm({
  form: 'billingTable',
  destroyOnUnmount: true,
  enableReinitialize: true,
})(BillingTable);

export default connect(mapState, mapDispatch)(withRouter(BillingTableWrapper));